import { translate } from "@atoms/atom-client/i18n";

/**
 * Menu entry of the parts list download. The file name and the content of the
 * parts list stay German (production document), only the entry is translated.
 */
export function getPartsListMenuLabel(): string {
  return translate("app.manufacturer.downloads.partsList", "Stückliste");
}
